import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GVars } from './system/gvars/gvars';
import { LoginController } from './controllers/login/loginController';
import { Cifrado } from './libraries/cifrado/cifrado';
import { Constantes } from './system/constantes/constantes';
import { Utiles } from './system/utiles/utiles';
import { Notificaciones } from './system/notificaciones/notificaciones';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Documento } from './models/documento/documento';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { DocumentoCategoria } from './models/documento/documentoCategoria';
import { Libro } from './models/libro/libro';
import { LibroCategoria } from './models/libro/libroCategoria';
import { Curso } from './models/curso/curso';
import { CursoCategoria } from './models/curso/cursoCategoria';
import { Usuario } from './models/usuario/usuario';

@NgModule({
  declarations: [AppComponent],

  entryComponents: [],

  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule,
    HttpClientModule],

  providers: [
    StatusBar,
    SplashScreen,
    HttpClient,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    GVars,
    Constantes,
    Utiles,
    Notificaciones,
    LoginController,
    Cifrado,
    Documento,
    DocumentoCategoria,
    Libro,
    LibroCategoria,
    Curso,
    CursoCategoria,
    Usuario,
    InAppBrowser
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
